import React, { useState, useEffect } from "react";
import { UploadStyled } from "./styled";
import cx from "classnames";
// import PropTypes from 'prop-types'
import { useDropzone } from "react-dropzone";
import { useTranslation } from "react-i18next";
import { Displays, Icons } from "components";
import { userService } from "apiServices";
import { toast } from "react-toastify";
import { IMG_PATH } from "utils/constants/imgPath";

const Upload = ({
  theme_standard,
  onChange,
  acceptType,
  value,
  maxMBFileSizeWarning,
  errors,
  label,
  placeholder,
  addMorePlaceholder,
  uploadApiUrl,
  disabled,
}) => {
  const customClass = cx({
    theme_standard: theme_standard,
  });

  const { t } = useTranslation(["common"]);

  const [_files, _setFiles] = useState([]);
  const [_isBgLoading, _setIsBgLoading] = useState();
  const [_uploadProgress, _setUploadProgress] = useState({});

  const renderAcceptType = (type) => {
    switch (type) {
      case "cover":
        return {
          "image/jpeg": [".jpeg", ".png"],
        };
      case "png":
        return {
          "image/png": [".png"],
        };
      case "audio":
        return ".mp3,audio/mpeg3";
      case "video":
        return { "video/": [] };
      case "csv":
        return { "text/csv": [".csv"] };
      case "img-pdf":
        return { "image/jpeg": [".jpeg", ".png"], "application/pdf": [".pdf"] };
      default:
        break;
    }
  };

  const { getRootProps, getInputProps } = useDropzone({
    noClick: disabled,
    accept: renderAcceptType(acceptType),
    onDrop: async (acceptedFiles) => {
      _setIsBgLoading(true);

      // สร้าง temporary file entry พร้อม progress
      const tempFileIndex = _files.length;
      const tempFiles = [..._files, null]; // placeholder สำหรับไฟล์ใหม่
      _setFiles(tempFiles);

      // เริ่ม progress จาก 0%
      _setUploadProgress((prev) => ({
        ...prev,
        [tempFileIndex]: 0,
      }));

      // จำลอง progress การอัพโหลด
      const progressInterval = setInterval(() => {
        _setUploadProgress((prev) => {
          const currentProgress = prev[tempFileIndex] || 0;
          if (currentProgress < 90) {
            return {
              ...prev,
              [tempFileIndex]: currentProgress + Math.random() * 15,
            };
          }
          return prev;
        });
      }, 200);

      if (maxMBFileSizeWarning) {
        let checkFileLimit = acceptedFiles.filter(
          (e) =>
            Number((e.size / 1024 / 1024).toFixed(2)) >
            Number(maxMBFileSizeWarning)
        );
        if (checkFileLimit && checkFileLimit.length > 0) {
          clearInterval(progressInterval);
          // ลบ temporary file entry
          const filteredFiles = _files.filter(
            (_, index) => index !== tempFileIndex
          );
          _setFiles(filteredFiles);
          _setUploadProgress((prev) => {
            const newProgress = { ...prev };
            delete newProgress[tempFileIndex];
            return newProgress;
          });
          _setIsBgLoading(false);
          alert(t("File size exceeds 8 MB", { ns: "common" }));
        } else {
          const bodyFormData = new FormData();
          bodyFormData.append("image", acceptedFiles[0]);
          let res = await uploadApiUrl(bodyFormData);

          clearInterval(progressInterval);

          if (res && res.status === 200) {
            // อัปเดตไฟล์จริงและตั้ง progress เป็น 100%
            const updatedFiles = [..._files];
            updatedFiles[tempFileIndex] = res.data.path;
            _setFiles(updatedFiles);

            _setUploadProgress((prev) => ({
              ...prev,
              [tempFileIndex]: 100,
            }));

            // ซ่อน progress หลังจาก 1 วินาที
            setTimeout(() => {
              _setUploadProgress((prev) => {
                const newProgress = { ...prev };
                delete newProgress[tempFileIndex];
                return newProgress;
              });
            }, 1000);

            _setIsBgLoading(false);
            onChange && onChange(updatedFiles);
          } else {
            // ลบ temporary file entry เมื่ออัพโหลดล้มเหลว
            const filteredFiles = _files.filter(
              (_, index) => index !== tempFileIndex
            );
            _setFiles(filteredFiles);
            _setUploadProgress((prev) => {
              const newProgress = { ...prev };
              delete newProgress[tempFileIndex];
              return newProgress;
            });
            _setIsBgLoading(false);
            toast.error(t("Please check the file. File may be too large.", { ns: "common" }));
          }
        }
      } else {
        const bodyFormData = new FormData();
        bodyFormData.append("image", acceptedFiles[0]);
        let res = await uploadApiUrl(bodyFormData);

        clearInterval(progressInterval);

        if (res && res.status === 200) {
          // อัปเดตไฟล์จริงและตั้ง progress เป็น 100%
          const updatedFiles = [..._files];
          updatedFiles[tempFileIndex] = res.data.path;
          _setFiles(updatedFiles);

          _setUploadProgress((prev) => ({
            ...prev,
            [tempFileIndex]: 100,
          }));

          // ซ่อน progress หลังจาก 1 วินาที
          setTimeout(() => {
            _setUploadProgress((prev) => {
              const newProgress = { ...prev };
              delete newProgress[tempFileIndex];
              return newProgress;
            });
          }, 1000);

          _setIsBgLoading(false);
          onChange && onChange(updatedFiles);
        } else {
          // ลบ temporary file entry เมื่ออัพโหลดล้มเหลว
          const filteredFiles = _files.filter(
            (_, index) => index !== tempFileIndex
          );
          _setFiles(filteredFiles);
          _setUploadProgress((prev) => {
            const newProgress = { ...prev };
            delete newProgress[tempFileIndex];
            return newProgress;
          });
          _setIsBgLoading(false);
          toast.error("กรุณาตรวจสอบไฟล์ ไฟล์อาจมีขนาดใหญ่เกินไป");
        }
      }
    },
  });

  useEffect(() => {
    if (value) {
      _setFiles(value);
    }
  }, [value]);

  const _handleRemove = async (index, data) => {
    let res = await userService.POST_MEDIA_DELETE({ path: data });
    if (res && res.status === 200) {
      let filesTemp = _files;
      filesTemp.splice(index, 1);
      _setFiles([...filesTemp]);
      onChange && onChange(filesTemp);
    }
  };

  return (
    <UploadStyled>
      <Displays.BGLoading visible={_isBgLoading} />
      <div className={customClass}>
        {label && <div className="label">{label}</div>}
        {_files && _files.length > 0 && (
          <div className="uploaded_files">
            {_files.map((file, index) => (
              <div key={index} className="file_item">
                <div className="file_container">
                  {file && (
                    <img
                      className="file_img"
                      alt="upload the receipt"
                      src={IMG_PATH + file}
                    />
                  )}

                  {/* แสดง placeholder สำหรับไฟล์ที่ยังอัพโหลดไม่เสร็จ */}
                  {!file && (
                    <div className="file_placeholder">
                      <Icons.Scan width={32} height={24} />
                    </div>
                  )}

                  {/* Progress bar วงกลม */}
                  {_uploadProgress[index] !== undefined &&
                    _uploadProgress[index] < 100 && (
                      <div className="progress_overlay">
                        <div className="circular_progress">
                          <svg width="60" height="60" className="progress_ring">
                            <circle
                              className="progress_ring_circle_bg"
                              stroke="#e6e6e6"
                              strokeWidth="4"
                              fill="transparent"
                              r="26"
                              cx="30"
                              cy="30"
                            />
                            <circle
                              className="progress_ring_circle"
                              stroke="#4CAF50"
                              strokeWidth="4"
                              fill="transparent"
                              r="26"
                              cx="30"
                              cy="30"
                              style={{
                                strokeDasharray: `${2 * Math.PI * 26}`,
                                strokeDashoffset: `${
                                  2 *
                                  Math.PI *
                                  26 *
                                  (1 - (_uploadProgress[index] || 0) / 100)
                                }`,
                                transition: "stroke-dashoffset 0.3s ease",
                              }}
                            />
                          </svg>
                          <div className="progress_text">
                            {Math.round(_uploadProgress[index] || 0)}%
                          </div>
                        </div>
                      </div>
                    )}

                  {file && (
                    <button
                      type="button"
                      className="remove_btn"
                      onClick={() => _handleRemove(index, file)}
                    >
                      <Icons.Close width={16} height={16} color="red" />
                    </button>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
        <div {...getRootProps({ className: "dropzone" })}>
          <input {...getInputProps()} />
          <div className="input_upload_container">
            {_files && _files.length > 0
              ? addMorePlaceholder ||
                t("Add More Receipt Photos", { ns: "common" })
              : placeholder || t("Upload the receipt", { ns: "common" })}
         
              <Icons.Scan width={32} height={24} />
          </div>
        </div>

        {maxMBFileSizeWarning && (
          <div className="upload_reccomment">
            *** ไฟล์ควรมีขนาดไม่เกิน {maxMBFileSizeWarning} mb
          </div>
        )}
        {errors && <div className="errors">{t(errors, { ns: "common" })}</div>}
      </div>
    </UploadStyled>
  );
};

Upload.propTypes = {};

export default Upload;
